import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { HiArrowNarrowDown, HiArrowNarrowUp } from "react-icons/hi";

const TableSort = ({ sortByOptions, onSortChange }: any) => {
  const [sortBy, setSortBy] = useState(sortByOptions[0]);
  const [sortByMenuOpen, setSearchByMenuOpen] = useState(false);

  const handleActiveElement = (elem: any) => {
    setSortBy(elem);
    setSearchByMenuOpen(false);
    onSortChange({
      [elem.key]: elem.dir,
    });
  };

  return (
    <div className="flex w-full h-full justify-start lg:justify-end">
      <DropdownMenu modal={false} open={sortByMenuOpen}>
        <DropdownMenuTrigger
          onClick={() => setSearchByMenuOpen(!sortByMenuOpen)}
          asChild
        >
          <div className="relative hover:bg-primary/90 bg-primary rounded-md cursor-pointer min-w-fit object-contain h-10 flex items-center justify-between px-2">
            <span className="flex h-full items-center gap-2 text-white">
              {sortBy.label}
              {sortBy.dir === 1 ? <HiArrowNarrowUp /> : <HiArrowNarrowDown />}
            </span>

            <ChevronDown className="h-4 w-4 ms-2 mt-1" />
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="mt-1 flex flex-col gap-y-1 border-none bg-black drop-shadow-2xl py-2 text-white">
          {sortByOptions.map((elem: any) => {
            return (
              <div
                key={elem?.key + elem?.dir}
                onClick={() => {
                  handleActiveElement(elem);
                }}
                className={`flex h-fit justify-between gap-10 rounded-none px-5 py-2 focus:border-none hover:cursor-pointer hover:bg-primary ${
                  sortBy.key === elem?.key && sortBy.dir === elem.dir
                    ? "bg-primary"
                    : ""
                }`}
              >
                <div className="group flex items-center gap-2">
                  <p
                    className={`text-sm 
                   ${sortBy.key === elem?.key ? "text-white" : "text-white"}`}
                  >
                    {elem?.label}
                  </p>

                  {elem.dir === 1 ? <HiArrowNarrowUp /> : <HiArrowNarrowDown />}
                </div>
              </div>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default TableSort;
